import {
  USER_REQUEST,
  USER_ERROR,
  USER_SUCCESS,

  USER_UPDATE_REQUEST,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_ERROR,
  USER_UPDATE_RESET,

  USER_CHANGE_PASS_REQUEST,
  USER_CHANGE_PASS_SUCCESS,
  USER_CHANGE_PASS_ERROR,
  USER_CHANGE_PASS_RESET,
} from "../actions/user";
import HTTP from "@/utils/http.js";
import Vue from "vue";
import { AUTH_LOGOUT } from "../actions/auth";

const state = {
  user_get_status: "",
  profile: { name: "" },
  profile_once_loaded : false,
  user_update_status: "",
  user_password_status: "",
};

const getters = {
  getProfile: state => state.profile,
  getUsername: state => state.profile ? state.profile.name || "" : "",
  getProfileDetails: state => state.profile ? state.profile.details || {} : {},
  getProfileEmail: state => state.profile&&state.profile.details ? state.profile.details.email : "",
  getProfileMobile: state => state.profile&&state.profile.details ? state.profile.details.mobile : "",
  isFiz: state => state.profile.type === 0,

  isDriver: state => state.profile.type === -1,
  //isDriver: state => state.profile.type === -1 || true,

  isProfileLoading: state => state.user_get_status === "loading",
  profileOnceLoaded : state => state.profile_once_loaded,

  isProfileUpdateLoading: state => state.user_update_status === "loading",
  isProfileUpdateSucceed: state => state.user_update_status === "success",

  isChangePassLoading: state => state.user_password_status === "loading",
  isChangePassSucceed: state => state.user_password_status === "success",
};

const actions = {
  [USER_REQUEST]: ({ commit, dispatch }) => {
    commit(USER_REQUEST);
    return HTTP({ url: "profile" })
      .then(resp => {
        commit(USER_SUCCESS, resp.data);
        console.log('USER_REQUEST')
      })
      .catch((err) => {
        commit(USER_ERROR);
        if (err.user_get_status === 401) {
          dispatch(AUTH_LOGOUT);
        }
      });
  },
  [USER_UPDATE_REQUEST]: ({ commit, dispatch }, req) => {
    return new Promise((resolve, reject) => {
      commit(USER_UPDATE_REQUEST);
      HTTP({ url: "profile", data: req, method: "POST" })
        .then(resp => {
          commit(USER_UPDATE_SUCCESS, { resp: resp.data, req });
          resolve(resp);
        })
        .catch(err => {
          commit(USER_UPDATE_ERROR, err);
          if (err.user_get_status === 401) {
            dispatch(AUTH_LOGOUT);
          }
          reject(err);
        });
    });
  },
  [USER_CHANGE_PASS_REQUEST]: ({ commit, dispatch }, req) => {
    return new Promise((resolve, reject) => {
      commit(USER_CHANGE_PASS_REQUEST);
      HTTP({ url: "profile/password", data: req, method: "POST" })
        .then(resp => {
          commit(USER_CHANGE_PASS_SUCCESS);
          resolve(resp);
        })
        .catch(err => {
          commit(USER_CHANGE_PASS_ERROR, err);
          if (err.user_get_status === 401) {
            dispatch(AUTH_LOGOUT);
          }
          reject(err);
        });
    });
  },
};

const mutations = {
  [USER_REQUEST]: state => {
    state.user_get_status = "loading";
  },
  [USER_SUCCESS]: (state, data) => {
    state.user_get_status = "success";
    Vue.set(state, "profile", data);
    state.profile_once_loaded = true;
  },
  [USER_ERROR]: state => {
    state.user_get_status = "error";
    state.profile_once_loaded = true;
  },

  [USER_UPDATE_REQUEST]: state => {
    state.user_update_status = "loading";
  },
  [USER_UPDATE_SUCCESS]: (state, data) => {
    state.user_update_status = "success";
    Vue.set(state.profile, "details", JSON.parse(data.req.body));
  },
  [USER_UPDATE_ERROR]: state => {
    state.user_update_status = "error";
  },
  [USER_UPDATE_RESET]: state => {
    state.user_update_status = "";
  },

  [USER_CHANGE_PASS_REQUEST]: state => {
    state.user_password_status = "loading";
  },
  [USER_CHANGE_PASS_SUCCESS]: state => {
    state.user_password_status = "success";
  },
  [USER_CHANGE_PASS_ERROR]: state => {
    state.user_password_status = "error";
  },
  [USER_CHANGE_PASS_RESET]: state => {
    state.user_password_status = "";
  },

  [AUTH_LOGOUT]: state => {
    state.user_get_status = "";
    state.profile = { name: "" };
    state.profile_once_loaded = false;
    state.user_update_status = "";
    state.user_password_status = "";
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};